<h2 mat-dialog-title>{{'workTask.template_settings' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" style="max-width:650px;" id="section" >

      <form [formGroup]="workTaskTemplateForm">
        <mat-form-field appearance="outline" class="w-50 pe-1">
          <mat-label>{{'taskTemplates.wt_title' | translate}}</mat-label>
          <input matInput type="text" formControlName="title" name="title" class="form-control" required [readonly]="!tasktemplateUserRights_update">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-50 ps-1">
          <mat-label>{{'taskTemplates.wt_group' | translate}}</mat-label>
          <mat-select formControlName="groupId">
            <mat-option [value]="undefined" [disabled]="!tasktemplateUserRights_update"> - </mat-option>
            @for (group of taskTemplateGroups; track group) {
              <mat-option [value]="group.id" [disabled]="!tasktemplateUserRights_update">{{group.title}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100" required>
          <mat-label>{{'workTask.taskType' | translate}}</mat-label>
          <mat-select formControlName="taskType" required>
            <mat-option value="create" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_create' | translate}} </mat-option>
            <mat-option value="update" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_update_existing' | translate}}</mat-option>
            <mat-option value="transform" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_transform' | translate}} </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'userGroups.title' | translate}}</mat-label>
          <mat-select multiple formControlName="userGroupIds">
            @for (group of userGroupList; track group) {
              <mat-option [value]="group.id" [disabled]="!tasktemplateUserRights_update">{{group.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (workTaskTemplateForm.value.taskType=='update' ) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'workTask.tridy_select' | translate}}</mat-label>
            <mat-select formControlName="tridySource">
              <mat-option value="select" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_list' | translate}}</mat-option>
              <mat-option value="scan" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_scan' | translate}} </mat-option>
              <mat-option value="scanQR" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_scanQR' | translate}} </mat-option>
              <mat-option value="scanNFC" [disabled]="!tasktemplateUserRights_update">{{'workTask.select_scanNFC' | translate}} </mat-option>
            </mat-select>
          </mat-form-field>
        }

        @if (workTaskTemplateForm.value.taskType!='transform') {
          <mat-form-field appearance="outline" class="w-100 p-0" >
            <mat-label>{{'contentTypes.contentType' | translate}}</mat-label>
            <mat-select formControlName="contentType" >
              <mat-option value="" [disabled]="!tasktemplateUserRights_update"> - </mat-option>
              <mat-option class="select-search-option">
                <ngx-mat-select-search
                  [(ngModel)]="contentTypeSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  placeholderLabel="DPP Vorlage suchen"
                  noEntriesFoundLabel="Keine DPP Vorlage gefunden">
                </ngx-mat-select-search>
              </mat-option>
              @for (content of filteredContentTypesList; track content) {
                <mat-option [value]="content.id" [disabled]="!tasktemplateUserRights_update">{{content.displayName}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <div class="form-control d-flex justify-content-between align-items-center p-3">
          {{'workTask.visible' | translate}}
          @if (!tasktemplateUserRights_update) {
            <mat-slide-toggle [checked]="workTaskTemplateForm.value.visibleInPass" [disabled]="!tasktemplateUserRights_update"></mat-slide-toggle>
          }
          @if (tasktemplateUserRights_update) {
            <mat-slide-toggle formControlName="visibleInPass" ></mat-slide-toggle>
          }
        </div>

        <div class="form-control d-flex justify-content-between align-items-center p-3 mt-3">
          {{'workTask.hidden' | translate}}
          @if (!tasktemplateUserRights_update) {
            <mat-slide-toggle [checked]="workTaskTemplateForm.value.hidden" [disabled]="!tasktemplateUserRights_update"></mat-slide-toggle>
          }
          @if (tasktemplateUserRights_update) {
            <mat-slide-toggle formControlName="hidden" ></mat-slide-toggle>
          }
        </div>

        <div class="form-control d-flex justify-content-between align-items-center p-3 mt-3">
          {{'workTask.gpsRequired' | translate}}
          @if (!tasktemplateUserRights_update) {
            <mat-slide-toggle [checked]="workTaskTemplateForm.value.gpsMandatory" [disabled]="!tasktemplateUserRights_update"></mat-slide-toggle>
          }
          @if (tasktemplateUserRights_update) {
            <mat-slide-toggle formControlName="gpsMandatory" ></mat-slide-toggle>
          }
        </div>

        <div class="form-control d-flex justify-content-between align-items-center p-3 mt-3">
          {{'workTask.showImages' | translate}}
          @if (!tasktemplateUserRights_update) {
            <mat-slide-toggle [checked]="workTaskTemplateForm.value.showImages" [disabled]="!tasktemplateUserRights_update"></mat-slide-toggle>
          }
          @if (tasktemplateUserRights_update) {
            <mat-slide-toggle formControlName="showImages" ></mat-slide-toggle>
          }
        </div>

        <div class="form-control d-flex justify-content-between align-items-center p-3 mt-3">
          {{'workTask.showComments' | translate}}
          @if (!tasktemplateUserRights_update) {
            <mat-slide-toggle [checked]="workTaskTemplateForm.value.showComment" [disabled]="!tasktemplateUserRights_update"></mat-slide-toggle>
          }
          @if (tasktemplateUserRights_update) {
            <mat-slide-toggle formControlName="showComment" ></mat-slide-toggle>
          }
        </div>

        @if (workTaskTemplateForm.value.taskType=='transform') {
          <div class="mt-4 transform">
            <label for="incoming_tridys" class="text-uppercase mb-3">{{'workTask.incoming_tridys' | translate}}</label>
            <div class="list-group pb-1 pe-1" style="max-height:300px; overflow-y: auto;">
              @for (incoming of workTaskTemplateForm.value.incomingTridys; track incoming; let index = $index) {
                <div class="list-group-item" >
                  <div class="d-flex align-items-center justify-content-between flex-nowrap" >
                    <div class="d-flex w-100 flex-column align-items-start" (click)="openIncomingTridy(incoming, index)">
                      <span class="font-weight-bold"> {{incoming.displayTitle}}</span>
                      <span class="font-weight-normal" style="font-size: 14px;"> {{getContentTypeIdName(incoming.contentTypeId)}}</span>
                      <span class="text-muted" style="font-size: 14px;"> {{getTridyMultiplicity(incoming.multiplicity)}}</span>
                      <span class="text-muted" style="font-size: 14px;"> {{getTridySelection(incoming)}}</span>
                    </div>
                    <button mat-icon-button [disabled]="!tasktemplateUserRights_update" (click)="deleteIncomingTridy(incoming, index);">
                      <span class="material-symbols-outlined" style="color: var(--accentGlobal);">
                        delete
                      </span>
                    </button>
                  </div>
                </div>
              }
            </div>
            <button mat-button
              class="secondary-gray-button my-2"
              (click)="addIncomingTridys();"
              [disabled]="!tasktemplateUserRights_update"
              >
              <mat-icon>add_circle</mat-icon> {{'workTask.add_incoming_tridys' | translate}}
            </button>
          </div>
        }

        @if (workTaskTemplateForm.value.taskType=='transform') {
          <div class="mt-4 transform" >
            <label for="outgoing_tridys" class="text-uppercase mb-3">{{'workTask.outgoing_tridys' | translate}}</label>
            <div class="list-group pb-1 pe-1" style="max-height:300px; overflow-y: auto;">
              @for (outgoing of workTaskTemplateForm.value.outgoingTridys; track outgoing; let index = $index) {
                <div class="list-group-item" >
                  <div class="d-flex align-items-center justify-content-between flex-nowrap">
                    <div class="d-flex w-100 flex-column align-items-start" (click)="openOutgoingTridy(outgoing, index);">
                      <span class="font-weight-bold"> {{outgoing.displayTitle}}</span>
                      <span class="font-weight-bold" style="font-size: 14px;"> {{getContentTypeIdName(outgoing.contentTypeId)}}</span>
                      <span class="font-weight-bold text-muted" style="font-size: 14px;"> {{getTridyAction(outgoing.actions)}}</span>
                    </div>
                    <button mat-icon-button [disabled]="!tasktemplateUserRights_update" (click)="deleteOutgoingTridy(outgoing, index);">
                      <span class="material-symbols-outlined" style="color: var(--accentGlobal);">
                        delete
                      </span>
                    </button>
                  </div>
                </div>
              }
            </div>
            <button mat-button
              class="secondary-gray-button my-2"
              (click)="addOutgoingTridys();"
              [disabled]="!tasktemplateUserRights_update"
              >
              <mat-icon>add_circle</mat-icon> {{'workTask.add_outgoing_tridys' | translate}}
            </button>
          </div>
        }

        @if (workTaskTemplateForm.value.taskType!='transform') {
          <div class="mt-4" >
            <label for="actions">{{'workTask.actions' | translate}}</label>
            <div class="mb-3 pt-2">
              <p class="text-muted" style="font-size: 14px;">{{'workTask.action_description' | translate}}</p>
              <button mat-button
                class="secondary-gray-button my-2"
                id="btn-add"
                [disabled]="!tasktemplateUserRights_update"
                [matMenuTriggerFor]="actionList"
                >
                <mat-icon>add_circle</mat-icon> {{'workTask.add' | translate}}
              </button>
              <mat-menu #actionList="matMenu">
                @for (sn of posibleActions; track sn) {
                  <div>
                    @if (!sn.isBeta || userHasBetaWidgetRole) {
                      <button [disabled]="!tasktemplateUserRights_update || (sn.value !== 'startWorkflow' && sn.added==true) || sn.disabled==true || workTaskTemplateForm.value.taskType=='transform'" mat-menu-item (click)="addAction(sn.name);">
                        @if (sn.value=='writeTag') {
                          <mat-icon>draw</mat-icon>
                        }
                        @if (sn.value=='verifyTag') {
                          <mat-icon>security_update_good</mat-icon>
                        }
                        @if (sn.value=='lockTag') {
                          <mat-icon>lock</mat-icon>
                        }
                        @if (sn.value=='verifyGermanPassport') {
                          <mat-icon>badge</mat-icon>
                        }
                        @if (sn.value=='faceId') {
                          <mat-icon>person_pin</mat-icon>
                        }
                        @if (sn.value=='startWorkflow') {
                          <mat-icon>play_arrow</mat-icon>
                        }
                        @if (sn.value=='print') {
                          <mat-icon>print</mat-icon>
                        }
                        <!-- <mat-icon *ngIf="sn.value=='faceId'">person_pin</mat-icon> -->
                        {{sn.translate | translate}}
                      </button>
                    }
                  </div>
                }
              </mat-menu>
              @for (s of posibleActions; track s; let index = $index) {
                <div class="list-group list-group-flush" >
                  @if (s.added && s.value !== 'startWorkflow' && (!s.isBeta || userHasBetaWidgetRole)) {
                    <div class="p-1 ps-3 list-group-item border-bottom">
                      <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                        <span id="{{s.name}}"> {{s.translate | translate}}</span>
                        <div >
                          <button mat-icon-button [disabled]="!tasktemplateUserRights_update" (click)="deleteAction(s, index);">
                            <span class="material-symbols-outlined" style="color: var(--accentGlobal);">
                              delete
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <!-- Display workflow actions (object-based actions) -->
              @for (action of allActionsNames; track action; let index = $index) {
                <div class="list-group list-group-flush" >
                  @if (isWorkflowAction(action) && userHasBetaWidgetRole) {
                    <div class="p-1 ps-3 list-group-item border-bottom">
                      <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                        <div class="d-flex flex-column">
                          <span>{{'workTask.action_start_workflow' | translate}}</span>
                          <span class="text-muted" style="font-size: 12px;">{{getWorkflowActionDisplayName(action)}}</span>
                        </div>
                        <div>
                          <button mat-icon-button [disabled]="!tasktemplateUserRights_update" (click)="editWorkflowAction(action);" class="me-1">
                            <span class="material-symbols-outlined" style="color: var(--accentGlobal);">
                              edit
                            </span>
                          </button>
                          <button mat-icon-button [disabled]="!tasktemplateUserRights_update" (click)="deleteWorkflowAction(action, index);">
                            <span class="material-symbols-outlined" style="color: var(--accentGlobal);">
                              delete
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </form>

    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" >{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="onDone();" [disabled]="!tasktemplateUserRights_update || workTaskTemplateForm.invalid">{{'apply' | translate}}</button>
</mat-dialog-actions>
